<div *ngIf="this.type === 'filter'" class="container">
     <mat-toolbar class="mat-accent m-0">
        <mat-toolbar-row fxFlex fxLayout="row" fxLayoutAlign="space-between center">
            <span class="title dialog-title">{{'eventform.filter' | transloco}}</span>
            <button mat-icon-button (click)="closeDialog()" aria-label="Close dialog">
                <mat-icon>close</mat-icon>
            </button>
        </mat-toolbar-row>
    </mat-toolbar>

    <div mat-dialog-content fxLayout="column" fxFlexAlign="center"
        class="event-form w-100-p p-24" fxLayout="column">
        <mat-form-field class="w-100-p paddingR paddingL" style="padding-top:1%" appearance="outline"
            floatLabel="always">
            <mat-label>{{'eventform.Type' | transloco}}</mat-label>
            <mat-select [(ngModel)]="typeSelect" placeholder="Type">
                <mat-option *ngFor="let type of types" [value]="type.value">
                    {{'eventform.' + type.nom | transloco}}
                </mat-option>
            </mat-select>
        </mat-form-field>
        <mat-form-field class="w-100-p paddingR paddingL" style="padding-top:1%"
            fxFlexAlign="center" appearance="outline" floatLabel="always">
            <mat-label>{{'eventform.Agent' | transloco}}</mat-label>
            <mat-select [(ngModel)]="agentSelect" placeholder="{{'eventform.Agent' | transloco}}">
                <mat-option *ngFor="let agent of agents" [value]="agent.id">
                    {{agent.username}}
                </mat-option>
            </mat-select>
        </mat-form-field>
        <mat-form-field class="w-100-p paddingR paddingL" style="padding-top:1%" fxFlexAlign="center"
            appearance="outline" floatLabel="always">
            <mat-label>{{'eventform.candidats' | transloco}}</mat-label>
            <mat-select mat-select [(ngModel)]="candidatSelect" placeholder="{{'eventform.candidats' | transloco}}">
                <mat-option *ngFor="let cand of cands" [value]="cand.id">
                    {{cand.username}} &nbsp; {{cand.tel1}}
                </mat-option>
            </mat-select>
        </mat-form-field>
        <mat-form-field class="w-100-p paddingR paddingL" style="padding-top:1%" fxFlexAlign="center"
            appearance="outline" floatLabel="always">
            <mat-label>{{'eventform.voiture' | transloco}}</mat-label>
            <mat-select mat-select [(ngModel)]="voiture" placeholder="{{'eventform.voiture' | transloco}}">
                <mat-option *ngFor="let voiture of voitures" [value]="voiture.id">
                    {{voiture.nom}}
                </mat-option>
            </mat-select>
        </mat-form-field>
    </div>
    <div fxLayout="row" class="p-12" fxLayoutAlign="end center" fxLayoutGap="4px">
        <div>
            <button mat-stroked-button class="save-button" aria-label="SAVE" #edit
                (click)="closeDialog()">
                {{'eventform.annuler' | transloco}}
            </button>
        </div>
        <div>
            <button color="primary" mat-raised-button class="save-button" aria-label="SAVE" #edit
                (click)="closeDialog(0)">
                {{'eventform.réinitialiser' | transloco}}
            </button>
        </div>
        <div >
            <button mat-raised-button class="save-button mat-accent" aria-label="SAVE" (click)="closee()">
                {{'eventform.chercher' | transloco}}
            </button>
        </div>
    </div>
</div>
<div *ngIf="this.type === 'stats'" style="padding : 0 !important">
    <mat-toolbar class="mat-accent">
        <mat-toolbar-row fxFlex fxLayout="row" fxLayoutAlign="space-between center">
            <span class="title dialog-title">{{'eventform.stats' | transloco}}</span>
            <button mat-icon-button (click)="closeDialog()" aria-label="Close dialog">
                <mat-icon>close</mat-icon>
            </button>
        </mat-toolbar-row>
    </mat-toolbar>
    <div mat-dialog-content fxLayoutAlign="center center" fxLayout="column" fxFlexAlign="center" fxLayout="column">
        <div fxLayout="row">
            <div class="w-50-p paddingR paddingL mr25" fxLayoutAlign="start center" fxLayout="row">
                <p style='font-size:100%;' class="whitespacenowrap">{{'eventform.Examen Code :' | transloco}} </p>
            </div>
            <div class="w-50-p paddingR paddingL ml25" fxLayoutAlign="start center" fxLayout="row">

                <p class="code-color codeEx"></p>
            </div>
        </div>
        <div fxLayout="row" style="padding-top: 5%">
            <div class="w-50-p paddingR paddingL mr25" fxLayoutAlign="start center" fxLayout="row">
                <p style='font-size:100%;' class="whitespacenowrap">{{'eventform.Séance Code :' | transloco}} </p>
            </div>
            <div class="w-50-p paddingR paddingL ml25" fxLayoutAlign="start center" fxLayout="row">
                <p class="code-color codeLess"> </p>
            </div>
        </div>
        <div fxLayout="row" style="padding-top: 5%">

            <div class="w-50-p paddingR paddingL mr25" fxLayoutAlign="start center" fxLayout="row">
                <p style='font-size:100%;' class="whitespacenowrap">{{'eventform.Examen Conduite :' | transloco}} </p>
            </div>
            <div class="w-50-p paddingR paddingL ml25" fxLayoutAlign="start center" fxLayout="row">
                <p class="code-color condEx"> </p>

            </div>
        </div>
        <div fxLayout="row" style="padding-top: 5%">

            <div class="w-50-p paddingR paddingL mr25" fxLayoutAlign="start center" fxLayout="row">
                <p style='font-size:100%;' class="whitespacenowrap">{{'eventform.Séance Conduite :' | transloco}} </p>
            </div>
            <div class="w-50-p paddingR paddingL ml25" fxLayoutAlign="start center" fxLayout="row">
                <p class="code-color condLess"></p>
            </div>
        </div>



    </div>

</div>